//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UsuarioCursos from '@/api/promotores/usuarios/cursos.api'
export default {
  data() {
    return {
      cursos: [],
      columns: [
        { name: 'id', field: 'id', label: 'ID', align: "left", style: "width: 80px",},
        { 
          name: 'curso', 
          field: 'curso', 
          label: 'Curso', 
          align: "left",
          classes: "bg-grey-2 ellipsis",
          style: "width: 250px",
          headerClasses: "bg-primary text-white",
          sortable: true, 
        },
        { name: 'calificacion', field: 'calificacion', label: 'Calificación', classes: 'text-capitalize' },
        { name: 'status', field: 'status', label: 'Estado', classes: 'text-capitalize' },
        { name: 'created_at', field: 'created_at', label: 'Creación', sortable: true, format: this.momentFromNow, },
      ],
      loading: false,
    }
  },

  mounted() {
		this.loadCursos()
	},

  methods: {
    async loadCursos() {
		  try {
        this.loading = true
        this.cursos = await UsuarioCursos.all(this.$route.params.promotor)
      } finally {
        this.loading = false
      }
    }
  }
}
